/**
 * The browser mirror of api/_utils/orgDoorProof.ts (job #801).
 *
 * An account that came in through an org sign-up link with no code carries
 * app_metadata.unclaimed_mint.minted_by === 'org_door' until its mailbox is
 * proved. app_metadata is service-role-writable only, so the learner cannot
 * clear it; the server clears it when they type an emailed code.
 *
 * The server gates the social layer. These two client gates cover what never
 * passes through our server: setting a password (straight to Supabase Auth)
 * and opening a Paddle checkout. Learning is never behind this.
 */
export const ORG_DOOR_MINT = 'org_door'

export function isOrgDoorUnconfirmed(
  user: { app_metadata?: Record<string, unknown> | null } | null | undefined,
): boolean {
  const marker = (user?.app_metadata || {}).unclaimed_mint as { minted_by?: unknown } | null | undefined
  return !!marker && typeof marker === 'object' && marker.minted_by === ORG_DOOR_MINT
}

export const CONFIRM_EMAIL_FIRST =
  'Please confirm your email first. We sent you a code when you joined, and you can ask for a new one in Settings.'
